import { useAtom } from "jotai";
import { colaboradoresAtom, openModalRegistrarPuntosAtom } from "../store/store";
import ColaboradorService from "services/ColaboradorService";
import { PuntosService } from "services/comunicacion-cultura";
import { notification } from "antd";
import usePuntosPage from "./usePuntosPage";

const useModalRegistrarPuntos = () => {

    const [open, setOpen] = useAtom(openModalRegistrarPuntosAtom);
    const [colaboradores, setColaboradores] = useAtom(colaboradoresAtom);
    const { fetchPuntos } = usePuntosPage();

    const abrirModal = () => {
        setOpen(true);
    }

    const cerrarModal = () => {
        setOpen(false);
    }

    const fetchColaboradores = async (value) => {
        const respuesta = await ColaboradorService.listarPorNombreCompletoODni({
            filtro: value.trim()
        });

        return respuesta.colaboradores.map((colaborador) => ({
            label: colaborador.nombreCompleto,
            value: colaborador.id,
        }));

    };

    const registrar = (formInstance) => {
        formInstance
            .validateFields()
            .then(async (formulario) => {

                await PuntosService.insertar({
                    anio: formulario.anio,
                    semana: formulario.semana,
                    puntos: formulario.puntos,
                    colaboradorId: formulario.colaborador.value
                });

                notification.success({
                    message: "Puntos registrados",
                    description: "Se realizó la operación exitosamente.",
                });

                formInstance.resetFields();
                fetchPuntos();
                cerrarModal();

            })
            .catch((info) => {
                console.log('Validate Failed:', info);
            });
    }

    return {
        open,
        colaboradores,
        abrirModal,
        cerrarModal,
        setColaboradores,
        fetchColaboradores,
        registrar
    };
};

export default useModalRegistrarPuntos;